/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useRef, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';

import {
    Dialog,
    DialogBody,
    DialogIcon,
    DialogText,
    ContentTextarea,
    DialogCancel,
    DialogConfirm,
} from './styles';

const mc = new MessageCenter();
const fitinsurApi = new FitinsurAPI();

export default function ModalEditConfirmation({ idOperation, show, setDialog, history }) {
    const [visible, setVisible] = useState(show);

    const authContext = useContext(GlobalAuthContext);
    const myRef = useRef();

    useEffect(() => {
        setVisible(show);
    }, [show]);

    const handleConfirm = (reset) => {
        fitinsurApi.setAuthToken(authContext.token);
        fitinsurApi.resetOperationState(idOperation, reset)
            .then(resp => resp.json())
            .then(data => {
                if (data.ret_code !== 200) {
                    mc.error(data.ret_msg_details);
                    return;
                }
                setDialog(false)
                history.push(data.ret_value.route, { idProduct: data.ret_value.idProduct });
            })
            .catch((error) => {
                mc.error("Failed" + error);
            });
    }

    return (
        <Dialog canShow={visible} >
            <DialogBody ref={myRef}>
                <DialogIcon pink={'exclamation'}>
                    <FontAwesomeIcon icon={['fas', 'exclamation']}></FontAwesomeIcon>
                    <DialogText>Important notice</DialogText>
                </DialogIcon>
                <ContentTextarea>
                    <p>
                        You have made a change to the policy details which were used to generate the NBI.  
                        Such change may materially affect underwriters’ assessment of the risk and/or the terms and conditions offered as part of the NBI.  
                    </p>
                    <p>
                        In the absence of a revised NBI, please only proceed where the confirmations noting the change, by relevant underwriters, are saved on file. 
                    </p>
                    <p>
                        {"If you click GENERATE NBI, you will re-generate the NBI's, otherwise click SAVE & RETURN to accept the changes and return to the original stage."}
                    </p>
                    <br />
                    <DialogCancel onClick={() => handleConfirm(false)}>{"SAVE & RETURN"}</DialogCancel>
                    <DialogConfirm onClick={() => handleConfirm(true)}>GENERATE NBI</DialogConfirm>
                </ContentTextarea>
            </DialogBody>
        </Dialog>

    );
}